import {customTrim} from '@bukalapak/toolbox-helper/string-helper';

export function removeSpecialChar(str) {
  return str.replace(/[^a-zA-Z0-9 ]/g, '');
}
export function generateURLString(str) {
  return customTrim(removeSpecialChar(str)).split(' ').join('-').toLowerCase();
}
export function getImages(couponDeal) {
  const temp = [];
  [...couponDeal.images].forEach((item) => {
    temp.push(item.url);
  });
  return temp;
}
export function ellipsisfy(text, length) {
  return text.length > length ? `${text.slice(0, length - 3)}...` : text;
}
export function encodeURI(obj) {
  return Object.entries(obj)
    .map(([key, val]) => {
      if (Array.isArray(val)) {
        return val.map((value) => `${key}=${escape(value)}`).join('&');
      }
      return `${key}=${escape(val)}`;
    })
    .join('&');
}
export function cleanupObject(obj) {
  const temp = Object.assign({}, obj);
  // clean up query from empty value
  Object.keys(temp).forEach((key) => {
    if (temp[key] === null || temp[key] === undefined || temp[key].length < 1) {
      delete temp[key];
    }
  });
  return temp;
}
export function renameKey(obj, oldKey, newKey) {
  const renamedObject = {...obj};
  delete Object.assign(renamedObject, {[newKey]: renamedObject[oldKey]})[oldKey];

  return renamedObject;
}

export function compare(a, b) {
  if (typeof a === 'number') {
    return a - b;
  }
  if (typeof a === 'string') {
    if (a.toLowerCase() > b.toLowerCase()) return 1;
    if (a.toLowerCase() < b.toLowerCase()) return -1;
  } else if (typeof a === 'boolean') {
    return a ? 1 : -1;
  }
  return 0;
}

export function simplify(str) {
  return `${str}`.toLowerCase().replace(/\s+/g, '');
}

export function escapeString(str, len = 32) {
  return str ? window.encodeURIComponent(`${str}`.substring(0, len).trim()) : str;
}

function redirect({to}) {
  const queryParams = window.location.search || '';
  window.location.replace(to + queryParams);
}

export function redirection({type, dealsId = '', giftable = false}) {
  const isFromGiftCardCreditsPage = window.location.href.includes('gift-card/credits');
  const isFromGiftCardCouponsPage = window.location.href.includes('gift-card/coupons');
  const isFromSubscriptionPage = window.location.href.includes('paket-langganan');
  const isFromCouponPage = window.location.href.includes('kupon');

  const giftCouponsDestination = `/gift-card/coupons/${dealsId}`;
  const giftCreditsDestination = `/gift-card/credits`;
  const subscriptionDestination = `/paket-langganan/${dealsId}`;
  const couponDealsDestination = `/kupon/${dealsId}`;

  const isGiftCard = type === 'giftcard';
  const isCouponDeals = type === 'coupon-deals';
  const isSubscription = type === 'subscription';

  if (isFromCouponPage) {
    if (isSubscription) redirect({to: subscriptionDestination});
    return;
  }

  if (!giftable && isCouponDeals) redirect({to: couponDealsDestination});

  if (giftable) {
    if (isGiftCard && !isFromGiftCardCreditsPage) redirect({to: giftCreditsDestination});
    if (isCouponDeals && !isFromGiftCardCouponsPage) redirect({to: giftCouponsDestination});
  }

  if (isSubscription && !isFromSubscriptionPage) {
    redirect({to: subscriptionDestination});
  }
}

export function swapItemArray(array, indexA, indexB) {
  const temp = array[indexA];
  array[indexA] = array[indexB];
  array[indexB] = temp;
}

export default {
  removeSpecialChar,
  generateURLString,
  getImages,
  ellipsisfy,
  encodeURI,
  cleanupObject,
  renameKey,
  compare,
  simplify,
  escapeString,
  redirection,
  swapItemArray,
};
